<div class="d-flex flex-column justify-content-around align-items-center disconnected">
    <div class='title'>
        <h1>{{ 'DISCONNECTED.TITLE' | translate | uppercase }}</h1>
    </div>
    <app-circle-progress [span]="duration" [progress]="time" [message]="'DISCONNECTED.RECONNECTING'"></app-circle-progress>
    <button (click)="attemptReconnect()" class="btn-rug confirm-button">{{ 'DISCONNECTED.RECONNECT' | translate | uppercase }}</button>
</div>
